<template>
  <div id="userGroups">
    <!-- 用户组列表卡片区 -->
    <el-card class="box-card">


      <el-row :gutter="20">
        <el-col :span="8">
          <el-input clearable size="small" :placeholder="$t('message.placeholder.input')" v-model="search"
            class="input-with-select" @clear="getUserGroupList()" @keyup.enter.native="searchUserGroup()">
            <el-button slot="append" icon="el-icon-search" @click="searchUserGroup"></el-button>
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button size="small" type="success" icon="el-icon-circle-plus-outline"
            @click="addNewUserGroup = true">{{ $t('message.button.add') }}</el-button>
        </el-col>
      </el-row>


      <el-dialog :close-on-click-modal="false" class="searchAddBomList" v-if='addNewUserGroup'
        :title="$t('message.title.add')" :visible.sync="addNewUserGroup" @close='dialogClose'>
        <CreateUserGroup :pageInfo='userGroupsName' @buttonClick='UGCreate()'></CreateUserGroup>

      </el-dialog>

      <div style="margin-top:22px">
        <vxe-grid v-bind="gridOptions" @cell-dblclick="userGroupInfo" :row-style="{ height: '56px' }"
          :cell-style="cellStyle">
          <template v-slot:operate="{ row }">
            <!-- <vxe-button icon="el-icon-view" :title="$t('message.button.check')" circle @click="userGroupInfo(row)"></vxe-button> -->
            <!-- <vxe-button icon="el-icon-setting" :title="$t('message.transform.assignRoles')" @click="assignRoles({row})" circle></vxe-button> -->
            <el-button icon="el-icon-setting" type="text" :title="$t('message.transform.assignRoles')"
              @click="assignRoles({ row })">{{ $t('message.transform.assignRoles') }}</el-button>
          </template>
          <template v-slot:is_enabled="{ row }">
            <el-switch v-model="row.status" @change="switchChange(row)" active-color="#13ce66"></el-switch>
          </template>
        </vxe-grid>
      </div>

      <!-- 分配角色对话框 -->
      <el-dialog center :title="$t('message.transform.assignRoles')" :visible.sync="assignDialogVisible" width="60%">
        <span>
          <template>
            <el-transfer :render-content="renderFunc" filterable :titles=tableName v-model="assignedRoles"
              :data="allRoles"></el-transfer>
          </template>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="assignDialogVisible = false"
            class="el-icon-close">{{ $t('message.button.cancel') }}</el-button>
          <el-button type="primary" @click="doAssignRoles"
            class="el-icon-check">{{ $t('message.button.affirm') }}</el-button>
        </span>
      </el-dialog>

    </el-card>
  </div>
</template>
<script>
import axios from "axios";
import CreateUserGroup from './CreateUserGroup';

export default {
  data() {
    return {
      tableName: [],
      // loading: true,
      assignDialogVisible: false,
      allRoles: [],
      assignedRoles: [],
      currentUserGroupId: "",
      // btnLoading: false,
      // btnDisabled: false,
      // loading: true,
      addNewUserGroup: false,
      listObj: '',
      searchGroupName: '',
      setObj: {},
      search: '',
      userGroupsName: '',
      searchList: [],

      gridOptions: {
        keepSource: true,
        resizable: true,
        // border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: 'id',
        height: "680",
        // size: "small",
        columns: [],
        data: [],
        editConfig: {
          trigger: 'manual',
          mode: 'row',
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },

        sortConfig: {
          trigger: 'cell'
        },
      },
      tableShow: true, //显示table
      //查询对象
      queryMap: {
        pageNum: 1,
        pageSize: 6,
        userGroupname: "",
        sex: "",
        nickname: ""
      },
      userGroupList: [],

    };
  },
  components: {
    CreateUserGroup
  },
  methods: {
    cellStyle({ row, rowIndex, column }) {
      //console.log(row);
      if (this.redCell.includes(rowIndex)) {
        return {
          // backgroundColor: '#f07381',
          color: '#ff0b00'
        }
      }
    },
    switchChange(row) {
      let vm = this;
      let object = {
        changeId: {},
        objectId: {
          classId: row.itemClassId,
          id: row.itemId,
          subClassId: row.itemSubClassId,
          version: "0",
        },
        pageOne: { 1092004: row.status ? "1" : "0" },
        pageThree: {},
        pageTwo: {},
      };
      axios.post('/pmdm/admin/userGroup/update', object)
        .then(res => {
          //console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
          }
          vm.searchUserGroup();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    renderFunc(h, option) {//左侧列表添加鼠标划上显示
      return <span title={option.label}>{option.label}</span>;
    },
    // createUserGroup() {
    //   this.$router.push("/createUserGroup");
    // },
    // search() {
    //   this.searchRoleList();
    // },
    UGCreate() {
      this.getUserGroupList();
      // console.log('ugcreate  151');

    },
    dialogClose() {
      this.getUserGroupList();
    },
    userGroupInfo(row) {
      const obj = {
        id: row.row.itemId,
        classId: row.row.itemClassId,
        subClassId: row.row.itemSubClassId,
        title: row.row[0],
      };

      this.getLink(obj);

      // console.log(m);
    },
    searchEvent() {
      this.findList()
    },
    handlePageChange({
      currentPage,
      pageSize
    }) {
      this.findList()
    },
    editRowEvent(row) {
      this.$refs.xGrid.setActiveRow(row)
    },
    saveRowEvent() {
      this.$refs.xGrid.clearActived().then(() => {
        // this.loading = true
        setTimeout(() => {
          // this.loading = false
          this.$XModal.message({
            message: this.$t('message.success.save'),
            status: 'success'
          })
        }, 300)
      })
    },
    removeRowEvent(row) {
      this.$XModal.confirm(this.$t('message.confirm.deleteData')).then(type => {
        if (type === 'confirm') {
          this.$refs.xGrid.remove(row)
        }
      })
    },

    /**
     * 重置
     */
    reset() {
      this.queryMap = {
        pageNum: 1,
        pageSize: 6,
        userGroupname: "",
        sex: "",
        nickname: ""
      };
    },
    downExcel() { },

    /**
     * 加载用户组列表
     */
    async getUserGroupList() {
      const {
        data: res
      } = await this.$http.get("/pmdm/admin/userGroup/getAll");
      //console.log(res);
      this.gridOptions.columns = this.getNewTableTitleData(res);
      const slotData = [{
        title: this.$t('message.table.isEnabled'),
        width: 180,
        slots: {
          default: 'is_enabled'
        }
      }, {
        title: this.$t('message.table.actions'),
        width: 180,
        slots: {
          default: 'operate'
        }
      }];
      this.gridOptions.columns = this.gridOptions.columns.concat(slotData);
      // this.gridOptions.columns.splice(3,1);
      const status_index = this.gridOptions.columns.findIndex(i => i.attid == "1092004");
      if (status_index != -1) {
        this.gridOptions.columns.splice(status_index, 1);
      }
      this.redCell = this.gridOptions.data.map((i, index) => {
        if (i.status == false) {
          return index
        }
      });
      this.gridOptions.data = this.getNewTableContentData(res);
      this.searchList = this.getNewTableContentData(res);
      this.userGroupsName = this.$t('message.title.userGroup')
      // let arr = res.object.table.rows;
      // for (let i = 0; i < arr.length; i++) {
      //   const e = arr[i];
      //   this.userGroupsName.push(e.cells[0].val);
      // }
      //this.tableShow = true;
    },

    /**
     * 弹出用户组分配角色
     */
    async assignRoles(row) {
      this.assignDialogVisible = true;
      let obj = {};
      console.log(row);
      obj.id = row.row.itemId + '';
      obj.classId = row.row.itemClassId + '';
      obj.subClassId = row.row.itemSubClassId + '';
      this.setObj = obj;

      //this.currentUserId = row.row.itemId;
      // const loading = this.$loading({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)"
      // });
      const {
        data: res
      } = await this.$http.get("/pmdm/admin/role/getAll");
      if (res.code == 200) {
        let arr = [];
        let roles = res.object.roles;
        roles.forEach((role) => {
          arr.push({
            key: role.id,
            label: role.name
          });
        });
        this.allRoles = arr;
        console.log(this.allRoles);
      }

      const {
        data: res1
      } = await this.$http.get(`/pmdm/admin/userGroup/getRoles${this.params(obj)}`);
      if (res1.code == 200) {
        let arr = [];
        let roles = res1.object.roles;
        roles.forEach((role) => {
          arr.push(role.id);
        });
        this.assignedRoles = arr;
        console.log(this.assignedRoles);
      }

      // setTimeout(() => {
      //   loading.close();
      //   this.assignDialogVisible = true;
      // }, 400);
    },
    /**
     * 确定分配角色
     */
    async doAssignRoles() {
      //this.assignDialogVisible = true;
      // this.btnLoading = true;
      // this.btnDisabled = true;

      this.assignedRoles = this.assignedRoles.map(i => {
        return i.toString()
      })
      const {
        data: res
      } = await this.$http.post(
        "/pmdm/admin/userGroup/assignRoles", {
        id: this.setObj.id,
        classId: this.setObj.classId,
        subClassId: this.setObj.subClassId,
        assignedRoles: this.assignedRoles
      }
      );
      if (res.code == 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.assignDialogVisible = false;
      // this.btnLoading = false;
      // this.btnDisabled = false;
    },
    /**
     * 搜索用户组
     */
    searchUserGroup() {
      // this.queryMap.pageNum = 1;
      // this.getUserGroupList();

      if (this.search != '') {
        let arr = this.searchList;

        let a = []
        for (let i = 0; i < arr.length; i++) {
          const e = arr[i];
          if (e[0].indexOf(this.search) > -1) {
            a.push(e)
          }
        }
        this.gridOptions.data = a;
      } else {
        this.getUserGroupList()
      }
    },

  },

  created() {
    console.log(this.Global);
    this.tableName = [
      this.$t("message.transform.choices"),
      this.$t("message.transform.selected"),
    ]
    this.getUserGroupList();
    // setTimeout(() => {
    //   // this.loading = false;
    // }, 500);
  }
};
</script>